<div class="logout-container">
  <div class="logout-icon">
    <mat-icon class="material-symbols-rounded outline">emergency_home</mat-icon>
  </div>
  
  <h6 class="logout-title">{{ 'auth.messages.confirmLogout' | translate }}</h6>
  
  <div class="logout-actions">
    <button class="cancel-btn btn btn-outline" (click)="onCancel()">
      {{ 'auth.buttons.cancelLogout' | translate }}
    </button>
    <button mat-raised-button color="primary" class="full-width btn btn-primary" (click)="onConfirm()">
      {{ 'auth.buttons.confirmLogout' | translate }}
    </button>
  </div>
</div>

